import React from 'react';
import PropTypes from 'prop-types';
import { getRangeBackgroundStyle, formatTime } from '../audioPlayerHelper';
import { ONE_HUNDRED_PERCENT, STYLES } from '../AudioPlayerConstants';

const { DEFAULT_BLUE_COLOR, WHITE } = STYLES;

const ProgressBar = ({ currentTime, duration, onSeek, onMouseUp, filledColor, unfilledColor }) => (
    <div className="timeline">
        <input
            type="range"
            className="progress-bar"
            style={{
                background: getRangeBackgroundStyle(
                    (currentTime * ONE_HUNDRED_PERCENT) / duration,
                    unfilledColor,
                    filledColor,
                ),
            }}
            min="0"
            value={currentTime}
            max={Math.floor(duration)}
            step={1}
            onChange={onSeek}
            onMouseUp={onMouseUp}
        />
        <div className="time-tracker">
            <span className="time">{formatTime(currentTime)}</span>/
            <span className="time">{formatTime(duration)}</span>
        </div>
    </div>
);

ProgressBar.defaultProps = {
    currentTime: 0,
    duration: 0,
    onSeek: () => {},
    onMouseUp: () => {},
    filledColor: DEFAULT_BLUE_COLOR,
    unfilledColor: WHITE,
};

ProgressBar.propTypes = {
    filledColor: PropTypes.string,
    unfilledColor: PropTypes.string,
    currentTime: PropTypes.number,
    duration: PropTypes.number,
    onSeek: PropTypes.func,
    onMouseUp: PropTypes.func,
};

export default ProgressBar;
